import { auth, db, collection, doc, addDoc, deleteDoc, getDocs, getDoc, query, where, serverTimestamp } from "./firebase";

// Find user by email
export const findUserByEmail = async (email) => {
  const usersRef = collection(db, "users");
  const q = query(usersRef, where("email", "==", email.toLowerCase()));
  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const userDoc = snapshot.docs[0];
  return {
    id: userDoc.id,
    ...userDoc.data(),
  };
};

// Add friend by email
export const addFriend = async (email) => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Not authenticated");

  // Can't add yourself
  if (email.toLowerCase() === currentUser.email.toLowerCase()) {
    throw new Error("No puedes agregarte a ti mismo");
  }

  // Find user by email
  const friendUser = await findUserByEmail(email);
  if (!friendUser) {
    throw new Error("No se encontró usuario con ese email");
  }

  // Check if already friends
  const friendsRef = collection(db, "friends");
  const existingQuery = query(friendsRef, where("userId", "==", currentUser.uid), where("friendId", "==", friendUser.id));
  const existing = await getDocs(existingQuery);

  if (!existing.empty) {
    throw new Error("Ya tienes a este usuario como amigo");
  }

  // Add friend relationship (one-way, each user manages their own list)
  const friendDoc = await addDoc(friendsRef, {
    userId: currentUser.uid,
    friendId: friendUser.id,
    friendEmail: friendUser.email,
    friendName: friendUser.displayName || friendUser.email,
    createdAt: serverTimestamp(),
  });

  return {
    id: friendDoc.id,
    friendId: friendUser.id,
    friendEmail: friendUser.email,
    friendName: friendUser.displayName || friendUser.email,
  };
};

// Remove friend
export const removeFriend = async (friendDocId) => {
  const currentUser = auth.currentUser;
  if (!currentUser) throw new Error("Not authenticated");

  await deleteDoc(doc(db, "friends", friendDocId));
};

// Get friends list
export const getFriends = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) return [];

  const friendsRef = collection(db, "friends");
  const q = query(friendsRef, where("userId", "==", currentUser.uid));
  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};

// Get friends who have added current user (to show notifications or mutual friends)
export const getPeopleWhoAddedMe = async () => {
  const currentUser = auth.currentUser;
  if (!currentUser) return [];

  const friendsRef = collection(db, "friends");
  const q = query(friendsRef, where("friendId", "==", currentUser.uid));
  const snapshot = await getDocs(q);

  return snapshot.docs.map((doc) => ({
    id: doc.id,
    ...doc.data(),
  }));
};
